import React, { Component } from 'react';
import {Button} from 'reactstrap';
import upload_file from './../../assets/upload_file.svg';

class UploadCategoryLanding extends Component {
  render() { 
    const {selectedCategory,categoryDescription,categoryIllustration} = this.props;
    return ( 
      <div className=" mb20">
        <div className="title-text" style={{fontWeight:'bolder'}}>
          {selectedCategory}
        </div>
        <hr />
        <div className="mt40 text-center import-data-page-container">
          <div>
            <img src={categoryIllustration}/>
          </div>
          <div className="mt40 mb40 import-data-subheader">
            {categoryDescription}
          </div>
          <Button
            className="continueBtn"
            onClick={this.props.nextStep}>
            <span className="continueBtnTxt">
              Get Started <span className="ml10 flaticon-next" />
            </span>
          </Button>
        </div>
      </div>
    );
  }
}
 
export default UploadCategoryLanding;
